import type { tAppState } from 'students/stores/rootStore';

export const selectArticles = (s: tAppState) => s.articles.items;
export const selectArticlesNextPage = (s: tAppState) => s.articles.nextPage;
export const selectArticlesUnreadCount = (s: tAppState) => s.articles.unreadCount;
export const selectArticlesIsLoading = (s: tAppState) => s.articles.isLoading;
export const selectArticlesIsLoadingMore = (s: tAppState) => s.articles.isLoadingMore;
export const selectArticlesPanelOpen = (s: tAppState) => s.articles.isPanelOpen;
export const selectCurrentArticle = (s: tAppState) => s.articles.currentArticle;
export const selectArticleIsLoading = (s: tAppState) => s.articles.isArticleLoading;
export const selectArticleError = (s: tAppState) => s.articles.error;
